export const altImage = (src) => {
    const isAltLanguageCode = ['cz', 'sk'].includes(window.config.language.code)

    if (isAltLanguageCode) {
        return src.replace('.', '-alt.');
    }

    return src
}
